var CurrentUser = /** @class */ (function () {
    function CurrentUser() {
        this.userRole = '';
        this.tenantId = 1;
        this.contextTenantId = 1;
        this.userName = '';
        this.userPhone = '';
        this.loginCount = 0;
        this.mfaEnabled = false;
        this.impersonatedUserId = -1;
    }
    CurrentUser.getInstance = function () {
        if (!CurrentUser.instance) {
            CurrentUser.instance = new CurrentUser();
        }
        return CurrentUser.instance;
    };
    Object.defineProperty(CurrentUser.prototype, "UserRole", {
        get: function () {
            return this.userRole;
        },
        set: function (role) {
            this.userRole = role;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CurrentUser.prototype, "TenantId", {
        get: function () {
            return this.tenantId;
        },
        set: function (newTenantId) {
            this.tenantId = newTenantId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CurrentUser.prototype, "ContextTenantId", {
        get: function () {
            return this.contextTenantId;
        },
        set: function (newTenantId) {
            this.contextTenantId = newTenantId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CurrentUser.prototype, "UserName", {
        get: function () {
            return this.userName;
        },
        set: function (name) {
            this.userName = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CurrentUser.prototype, "UserPhone", {
        get: function () {
            return this.userPhone;
        },
        set: function (phone) {
            this.userPhone = phone;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CurrentUser.prototype, "LoginCount", {
        get: function () {
            return this.loginCount;
        },
        set: function (loginCount) {
            this.loginCount = loginCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CurrentUser.prototype, "MfaEnabled", {
        get: function () {
            return this.mfaEnabled;
        },
        set: function (mfaEnabled) {
            this.mfaEnabled = mfaEnabled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CurrentUser.prototype, "ImpersonatedUserId", {
        get: function () {
            return this.impersonatedUserId;
        },
        set: function (newImpersonatedUserId) {
            this.impersonatedUserId = newImpersonatedUserId;
        },
        enumerable: false,
        configurable: true
    });
    return CurrentUser;
}());
export { CurrentUser };



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/currentUser/CurrentUser.ts
// module id = 212
// module chunks = 0